import OfferOutUrl from '@/components/shared/OfferOutUrl';
import { getBaseImageUrl, getMerchantHref } from '@/constants/hooks';
import { OffersMerchant, OffersOffer } from '@/services/dataTypes';
import Image from 'next/image'
import Link from 'next/link'
import React from 'react'

interface Props {
    data: OffersOffer;
    merchant?: OffersMerchant;
    height?: number;
    offerLink?: string | null;
    mer_slug?: string;
    slug_type?: string;
    domain: string;
    unoptimized?: boolean;
    width?: number;
}

const Banner = ({ data, height, offerLink, mer_slug, slug_type, domain, unoptimized=false, width}: Props) => {
    const { banner_image, url } = data?.offer ?? {};

    return (
        <div className="group w-full max-w-[1100px] mx-auto px-2">
            <div className="relative overflow-hidden rounded-2xl transition-all duration-500 ease-out hover:shadow-2xl hover:shadow-blue-500/10 hover:-translate-y-1">
                {mer_slug && slug_type ? (
                    <OfferOutUrl 
                        outUrl={offerLink || url} 
                        unique_id={data.offer.unique_id} 
                        merchantHref={getMerchantHref(data?.merchant, mer_slug, slug_type)} 
                        domain={domain}
                    >
                        <div className="relative overflow-hidden bg-white">
                            {/* Decorative Overlay */}
                            <div className="absolute inset-0 bg-gradient-to-tr from-blue-500/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none" />
                            
                            <Image
                                src={getBaseImageUrl(domain, banner_image, "")}
                                alt={`${data.merchant.merchant_name} discount coupons and deals`}
                                className="w-full object-contain mx-auto transition-transform duration-700 group-hover:scale-[1.02]"
                                loading='lazy'
                                height={height || 220}
                                width={width || 1000}
                                unoptimized={unoptimized}
                            />
                        </div>
                    </OfferOutUrl>
                ) : (
                    <Link 
                        href={offerLink || url} 
                        rel="nofollow sponsored noopener noreferrer" 
                        className="block relative overflow-hidden bg-white"
                    >
                        <Image
                            src={getBaseImageUrl(domain, banner_image, "")}
                            alt="Merchant Promotional Banner"
                            className="w-full object-contain mx-auto transition-transform duration-700 group-hover:scale-[1.02]"
                            loading='lazy'
                            width={width || 1000}
                            height={height || 220}
                            unoptimized={unoptimized}
                        />
                    </Link>
                )}
            </div>
        </div>
    )
};

export default Banner;